// extracted by mini-css-extract-plugin
module.exports = {"noResults":"NoResults--noResults--3APwe","fade":"NoResults--fade--1OUYK"};